module.exports = __webpack_public_path__ + "img/zip-file.58c51094.svg";